import { InlineWarning } from "@/components/common/Primitives";
import { num } from "@/lib/format";

export const OpportunityNotices = ({ error, providerIssues, providerFailures, refreshRun }) => (
  <>
    {error && (
      <div
        className="mb-3 rounded-sm border border-red-300 bg-red-50 px-3 py-2 text-[12px] text-red-800"
        data-testid="opportunities-error"
      >
        {error}
      </div>
    )}

    {providerIssues.length > 0 && (
      <div className="mb-3 space-y-2">
        {providerIssues.map((p) => (
          <InlineWarning
            key={`${p.provider}-${p.message}`}
            tone={p.status === "NOT_CONFIGURED" ? "danger" : "warning"}
          >
            <b>{p.label || p.provider}</b> — {p.message}
          </InlineWarning>
        ))}
      </div>
    )}

    {providerFailures.length > 0 && (
      <div className="mb-3 space-y-2" data-testid="scan-provider-warning">
        {providerFailures.map((item) => (
          <InlineWarning key={`${item.label}-${item.message}`} tone="danger">
            <b>{item.label}</b> leverde bij de laatste verversing
            {item.scan ? ` (${item.scan})` : ""} geen advertenties: {item.message} Bestaande
            voertuigen hieronder komen uit de vorige geslaagde scan.
          </InlineWarning>
        ))}
      </div>
    )}

    {refreshRun?.status === "RUNNING" && (
      <div className="mb-3" data-testid="refresh-run-progress">
        <InlineWarning tone="info">
          Alles verversen bezig: {num(refreshRun.completed)} / {num(refreshRun.total)}{" "}
          zoekopdrachten
          {refreshRun.current_label ? ` — nu: ${refreshRun.current_label}` : ""}. Nieuwe
          advertenties en prijswijzigingen verschijnen zodra een zoekopdracht klaar is.
        </InlineWarning>
      </div>
    )}
  </>
);

export const OpportunityTabs = ({ tabs, view, onSelect }) => (
  <div className="mb-3 flex flex-wrap gap-1.5" role="tablist" data-testid="opportunity-tabs">
    {tabs.map((tab) => (
      <button
        key={tab.key}
        type="button"
        role="tab"
        aria-selected={view === tab.key}
        onClick={() => onSelect(tab.key)}
        data-testid={`tab-${tab.key}`}
        className={`rounded-sm border px-3 py-1.5 text-[12px] font-semibold transition-colors duration-150 ${
          view === tab.key
            ? "border-blue-600 bg-blue-600 text-white"
            : "border-slate-300 bg-white text-slate-700 hover:bg-slate-100"
        }`}
      >
        {tab.label}
      </button>
    ))}
  </div>
);
